/**
 * External (third-party or Cisco corporate-site) URLs that are referenced from
 * more than one place in the app, or that have a fixed identifier (form id,
 * campaign code) worth naming.
 *
 * Prefer extracting URLs here over duplicating them inline, so that changes
 * (e.g. domain moves, campaign code updates) only need to happen once.
 */

/** Cisco IT Service Desk customer portal (Help & Support links). */
export const SERVICEDESK_PORTAL_URL =
  "https://servicedesk.certsite.net/jira/servicedesk/customer/portal/3";

/** Learning with Cisco Centralized Support portal — CE credit / certification support cases. */
export const CE_CERT_SUPPORT_PORTAL_URL =
  "https://cisco-learning-support.atlassian.net/helpcenter/lwcsupport/";

/** Cisco U. My Learning CE portal — where learners track earned CE credits. */
export const CE_PORTAL_URL = "https://u.cisco.com/my-learning/ce-portal";

/** CertMetrics — schedule a certification exam. */
export const CERTMETRICS_SCHEDULE_EXAM_URL =
  "https://cp.certmetrics.com/cisco/en/schedule/schedule-exam";

/** CertMetrics — candidate login. */
export const CERTMETRICS_LOGIN_URL = "https://cp.certmetrics.com/cisco/en/login";

/** CCIE — schedule online lab exam. */
export const CCIE_SCHEDULE_LAB_URL =
  "https://ccie.cloudapps.cisco.com/CCIE/Schedule_Lab/CCIEOnline/CCIEOnline";

/** Marketo "Contact Sales / Request a Demo" form for Cisco U. */
export const MARKETO_CONTACT_SALES_URL =
  "https://mkto.cisco.com/ciscou-contact-sales.html?utm_campaign=ciscou&utm_source=web-cu&utm_medium=cu-unauth";

/** Cisco corporate page describing Learning Credits. */
export const LEARNING_CREDITS_URL =
  "https://www.cisco.com/c/en/us/training-events/training-certifications/training/learning-credits.html";

/** NetAcad Ethical Hacker free course (used on the Ethical Hacker challenge page). */
export const NETACAD_ETHICAL_HACKER_URL = "https://www.netacad.com/courses/ethical-hacker/";

/** Cisco corporate Ethical Hacker certification overview page. */
export const CISCO_ETHICAL_HACKER_PAGE_URL =
  "https://www.cisco.com/site/us/en/learn/training-certifications/certifications/ethical-hacker/index.html";
